<template>
  <div v-if="$apollo.loading">
    <spinner />
  </div>
  <main v-else>
    <header>
      <img src="/assets/color-logo.svg" alt />
      <span>ID #{{ reportId }}</span>
    </header>
    <dl>
      <dt>Prodajna organizacija</dt>
      <dd>{{ organizationName }}</dd>
      <dt>Datum i vrijeme izrade obračuna</dt>
      <dd>{{ formatDateTime(now) }}</dd>
    </dl>
    <h1>Obračun prodanih ulaznica OB-{{ reportId }}/{{ getYear(now) }}</h1>
    <p class="event-title">{{ organizationName }}</p>
    <p class="sale-period">Za period od {{ formatDate(from) }} do {{ formatDate(to) }}</p>
    <table>
      <thead>
        <tr>
          <th>Br.</th>
          <th>Prodavač</th>
          <th>Event</th>
          <th>Naziv</th>
          <th>Jed. cijena</th>
          <th v-if="organizationFees.ticketAdditionalFeeAmount > 0">Naknada po ulaznici</th>
          <th>Količina</th>
          <th>Ukupno</th>
        </tr>
      </thead>
      <tbody>
        <tr v-bind:key="index" v-for="(order, index) in orders">
          <td>{{ index + 1 }}.</td>
          <td>{{ order.email }}</td>
          <td>{{ order.eventTitle }}</td>
          <td>{{ order.name }}</td>
          <td>{{ order.price }}&nbsp;EUR</td>
          <td v-if="organizationFees.ticketAdditionalFeeAmount > 0">
            {{ order.organizationFees.ticketAdditionalFeeAmount * 1.25 }} EUR
          </td>
          <td>{{ order.count }}</td>
          <td>
            {{
              order.totalPrice +
              order.count * (order.organizationFees.ticketAdditionalFeeAmount * 1.25)
            }}&nbsp;EUR
          </td>
        </tr>
        <tr
          v-for="(order, index) in refundedOrders"
          :key="orders.length + index + 1"
          style="color: red"
        >
          <td>{{ orders.length + index + 1 }}.</td>
          <td>{{ order.email }}</td>
          <td>{{ order.eventTitle }}</td>
          <td>{{ order.name }}</td>
          <td>{{ order.price }}&nbsp;EUR</td>
          <th v-if="organizationFees.ticketAdditionalFeeAmount > 0" style="color: red">
            {{ formatDateTime(order.orderRefunded) }}h
          </th>
          <td>-{{ order.count }}</td>
          <td>-{{ order.totalPrice }}&nbsp;EUR</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td :colspan="organizationFees.ticketAdditionalFeeAmount > 0 ? 6 : 5">Sveukupno:</td>
          <td>{{ totalSoldCount }}</td>
          <td>{{ totalSoldAmountWithOrganizerAdditionalFee }}&nbsp;EUR</td>
        </tr>
      </tfoot>
    </table>
    <p v-if="organizationId !== 1" style="margin-bottom: 1rem">
      Ukupna CoreEvent Naknada za ulaznice: {{ round(totalCoreEventFeeAmountWithoutVat, 2) }} EUR +
      PDV (25%) = {{ round(totalCoreEventFeeAmountWithoutVat * 1.25, 2) }} EUR
    </p>
    <p>
      {{ organizationName }} provizija ({{ organizationFees.ticketPercentageFee }}%):
      {{ ticketPercentageFeeWithoutVAT }} EUR + PDV (25%) =
      {{ round(ticketPercentageFeeWithVAT, 2) }} EUR
    </p>
    <div v-if="organizationId !== 1">
      <p>
        {{ organizationName }} provizija od CoreEvent Naknada za ulaznice (50%) =
        {{ round(totalCoreEventFeeAmountWithoutVat / 2, 2) }} EUR + PDV (25%) =
        {{ round((totalCoreEventFeeAmountWithoutVat * 1.25) / 2, 2) }} EUR
      </p>
      <p>
        Ukupna {{ organizationName }} provizija = {{ ticketPercentageFeeWithoutVAT }} EUR +
        {{ round(totalCoreEventFeeAmountWithoutVat / 2, 2) }} EUR + PDV (25%) =
        {{
          round(
            (Number(ticketPercentageFeeWithoutVAT) + totalCoreEventFeeAmountWithoutVat / 2) * 1.25,
            2,
          )
        }}
        EUR
      </p>
    </div>
    <p v-if="organizationId === 1">
      {{ organizationName }} fiksna naknada ({{
        100 - organizationFees.coreEventAdditionalFeePercentage
      }}%): {{ fixedTicketAdditionalFeeAmountWithoutVAT }} EUR + PDV (25%) =
      {{ fixedTicketAdditionalFeeAmountWithVAT }}
    </p>
    <p>Za isplatu CoreEventu: {{ round(coreEventShare, 2) }} EUR</p>
  </main>
</template>

<script>
import moment from 'moment'
import { round } from 'lodash'
import { GET_TICKET_SELLERS_ADMIN_REPORT } from '@/graphql/order.graphql'
import { GET_LOGGED_USER } from '@/graphql/user.graphql'
import { exchangeRate } from '../../utils'
import { OrderStatusEnum } from '@/types'

export default {
  props: {
    from: {
      type: String,
      default: null,
    },
    to: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      orders: [],
      seller: null,
      exchangeRate: exchangeRate,
      totalSoldCount: 0,
      totalRefundedCount: 0,
      totalRefundedAmount: 0,
      totalSoldAmountWithOrganizerAdditionalFee: 0,
      reportId: null,
      now: new Date(),
      organizationName: null,
      ticketPercentageFeeWithVAT: 0,
      ticketPercentageFeeWithoutVAT: null,
      fixedTicketAdditionalFeeAmountWithoutVAT: null,
      refundedOrders: [],
      fixedTicketAdditionalFeeAmountWithVAT: null,
      coreEventShare: null,
      totalCoreEventFeeAmountWithoutVat: 0,
      organizationId: null,
      organizationFees: {},
      fixedFeeItems: [],
      priceWithoutOrganizerTicketAdditionalFeeAmount: null,
    }
  },
  methods: {
    round,
    formatDate(date) {
      return moment(date).format('DD. MM. YYYY')
    },
    formatDateTime(date) {
      return moment(date).format('DD. MM. YYYY HH:mm')
    },
    getYear(date) {
      return moment(date).year()
    },
  },
  apollo: {
    getTicketSellersAdminReport: {
      query: GET_TICKET_SELLERS_ADMIN_REPORT,
      variables() {
        return {
          from: this.from,
          to: this.to,
        }
      },
      manual: true,
      result({ data, loading }) {
        if (loading || !data.getTicketSellersAdminReport) {
          return
        }
        const { getTicketSellersAdminReport } = data
        const modifiedData = []
        const successfulOrders = getTicketSellersAdminReport.filter(o =>
          [OrderStatusEnum.SUCCESSFUL, OrderStatusEnum.REFUND_REQUESTED].includes(o.status),
        )

        this.refundedOrders = getTicketSellersAdminReport.filter(
          o =>
            o.status === OrderStatusEnum.REFUNDED &&
            moment(o.orderRefunded).isBetween(moment(this.from), moment(this.to)),
        )
        getTicketSellersAdminReport.forEach(o => {
          if (
            moment(o.orderCreated).isBetween(moment(this.from), moment(this.to)) &&
            o.status === OrderStatusEnum.REFUNDED
          ) {
            successfulOrders.push(o)
          }
        })
        this.refundedOrders.map(o => {
          this.totalRefundedCount += o.count
          this.totalRefundedAmount += parseFloat(o.totalPrice)
        })

        successfulOrders.map(d => {
          const existingData = modifiedData.find(m => m.id === d.id)
          if (existingData) {
            existingData.totalPrice = parseFloat(existingData.totalPrice) + parseFloat(d.totalPrice)
            existingData.count = parseInt(existingData.count) + parseInt(d.count)
          } else {
            modifiedData.push({
              ...d,
            })
          }
          if (
            d.fiscalisationInfo &&
            d.fiscalisationInfo.useEventFeePerTicket &&
            !d.fiscalisationInfo.fiscalisationError
          ) {
            d.fiscalisationInfo['full_receipt'].items.map(i => {
              if (i.name.includes(CoreEventFeeType.TICKET)) {
                const existingFee = this.fixedFeeItems.find(fee => fee.name === i.name)
                if (existingFee && existingFee.orderId.includes(d.orderId)) {
                  return
                }
                if (existingFee) {
                  existingFee.count += i.amt / 1000
                  existingFee.totalPrice += i.price / 100
                  existingFee.orderId.push(d.orderId)
                } else {
                  this.fixedFeeItems.push({
                    orderId: [d.orderId],
                    eventTitle: d.eventTitle,
                    name: i.name,
                    count: i.amt / 1000,
                    totalPrice: i.price / 100,
                    singleItemPrice: i['single_item_price'] / 100,
                  })
                }
              }
            })
          }
        })

        this.organizationId = modifiedData[0].organizationId
        this.organizationName = modifiedData[0].organizationName
        this.organizationFees = modifiedData[0].organizationFees
        this.orders = modifiedData
        this.totalSoldCount =
          modifiedData.reduce((sum, order) => sum + order.count, 0) - this.totalRefundedCount

        this.priceWithoutOrganizerTicketAdditionalFeeAmount =
          modifiedData.reduce((sum, order) => sum + order.totalPrice, 0) - this.totalRefundedAmount
        this.totalCoreEventFeeAmountWithoutVat =
          this.fixedFeeItems.reduce((acc, curr) => (acc += curr.totalPrice), 0) / 1.25
        this.totalSoldAmountWithOrganizerAdditionalFee =
          this.priceWithoutOrganizerTicketAdditionalFeeAmount +
          this.totalSoldCount * (this.orders[0].organizationFees.ticketAdditionalFeeAmount * 1.25)

        this.ticketPercentageFeeWithoutVAT = (
          this.priceWithoutOrganizerTicketAdditionalFeeAmount *
          (this.organizationFees.ticketPercentageFee / 100)
        ).toFixed(2)

        this.ticketPercentageFeeWithVAT = this.ticketPercentageFeeWithoutVAT * 1.25

        this.fixedTicketAdditionalFeeAmountWithoutVAT = (
          this.totalSoldCount *
          this.organizationFees.ticketAdditionalFeeAmount *
          ((100 - this.organizationFees.coreEventAdditionalFeePercentage) / 100)
        ).toFixed(2)

        this.fixedTicketAdditionalFeeAmountWithVAT = (
          this.fixedTicketAdditionalFeeAmountWithoutVAT * 1.25
        ).toFixed(2)

        this.coreEventShare =
          this.totalSoldAmountWithOrganizerAdditionalFee -
          this.ticketPercentageFeeWithVAT -
          this.fixedTicketAdditionalFeeAmountWithVAT
        if (this.organizationId !== 1) {
          const halfCoreEventFeeWithVAT = (this.totalCoreEventFeeAmountWithoutVat * 1.25) / 2
          this.coreEventShare += halfCoreEventFeeWithVAT
        }
      },
    },
    me: {
      query: GET_LOGGED_USER,
      result({ data, loading }) {
        if (!loading && data) {
          const { me: user } = data
          this.seller = user
          this.reportId = `${user.id}${this.now.getDate()}${this.now.getMonth() + 1}${
            this.now.getHours() * 60 + this.now.getMinutes()
          }`
        }
      },
    },
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body {
  height: 100%;
}

main {
  height: 100%;
  padding: 0.33333in 0.22222in 0.33333in 0.44444in;
}

header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.33333in;
}

header img {
  height: 0.33333in;
}

header span {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.13889in;
  line-height: 120%;
  text-align: right;
  color: #979797;
}

dl {
  margin-bottom: 0.33333in;
}

dl dt {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.11111in;
  line-height: 120%;
  color: #979797;
  margin-bottom: 0.02777in;
}

dl dd {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.13889in;
  line-height: 120%;
  color: #666666;
}

dl dd + dt {
  margin-top: 0.11111in;
}

h1 {
  font-family: 'Raleway', sans-serif;
  font-weight: 800;
  font-size: 0.25in;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #333333;
}

.event-title {
  font-family: 'Raleway', sans-serif;
  font-weight: 800;
  font-size: 0.25in;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #979797;
  margin-bottom: 0.11111in;
}

.sale-period {
  font-family: 'Raleway', sans-serif;
  font-weight: 600;
  font-size: 0.16777in;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #979797;
  margin-bottom: 0.33333in;
}

table {
  width: 100%;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.13889in;
  line-height: 120%;
  color: #333333;
  border-collapse: collapse;
  margin-bottom: 1.5rem;
}

table thead {
  background: #e6f1f8;
}

table th {
  font-weight: normal;
  color: #0277bd;
}

table th,
table td {
  padding: 0.08333in 0.11111in;
}

table th:nth-child(-n + 3),
table tbody td:nth-child(-n + 3) {
  text-align: left;
}

table th:nth-child(n + 4),
table tbody td:nth-child(n + 4) {
  text-align: right;
}

table tfoot {
  background: #e6f1f8;
}

table tfoot td {
  color: #0277bd;
  text-align: right;
}

table tr:nth-child(even) {
  background: #f5f5f5;
}

.vat-info {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.11111in;
  line-height: 120%;
  color: #666666;
  margin-top: 0.33333in;
  text-align: right;
}
</style>
